import logo from "./logo.svg";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
//import { BrowserRouter as Router, useRoutes } from 'react-router-dom';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom"; // Import Routes and other components
import { AuthProvider } from "./AuthContext";
import ProtectedRoute from "./ProtectedRoute";
import LoginForm from "./Component/LoginForm";
import Dashboard from "./Component/Dashboard";
import Logout from "./Component/Logout";
import Managerreadingdetail from "./Component/manager/Managerreadingdetail";
import Managerreadingedit from "./Component/manager/Managerreadingedit";
import Credit from "./Component/manager/Credit";
import Creditdetail from "./Component/manager/Creditdetail";
import Loan from "./Component/manager/Loan";
import Production from "./Component/manager/Production";
import Sales from "./Component/manager/Sales";
import CustomerForm from "./Component/CustomerForm";

const App = () => (
  <AuthProvider>
    <Router>
      <Routes>
        <Route path="/" element={<LoginForm />} />
        <Route
          path="/dashboard"
          element={<ProtectedRoute element={<Dashboard />} />}
        
        />

        <Route
          path="/managerreadingdetail/:id"
          element={<ProtectedRoute element={<Managerreadingdetail />} />}
        />

        <Route
          path="/managerreadingedit/:id"
          element={<ProtectedRoute element={<Managerreadingedit />} />}
        />
        <Route
          path="production"
          element={<ProtectedRoute element={<Production />} />}
        />

        <Route
          path="/sales"
          element={<ProtectedRoute element={<Sales />} />}
        />

        <Route
          path="/credit"
          element={<ProtectedRoute element={<Credit />} />}
        />
        <Route
          path="/creditdetail/:id"
          element={<ProtectedRoute element={<Creditdetail />} />}
        />
        <Route path="/loan" element={<ProtectedRoute element={<Loan />} />} />

        <Route
          path="/logout"
          element={<ProtectedRoute element={<Logout />} />}
        />

        <Route path="*" element={<Navigate to="/" />} />
        <Route path="/costomercont" element={<CustomerForm />} />
      </Routes>
    </Router>
  </AuthProvider>
);

export default App;
